import React, { useState, useEffect } from 'react';
import bigInt from 'big-integer';

export function CalendarTime({ date, calendar, update }) {
  const handleTimeUpdate = (timeChange) => {
    update(timeChange);
  };
  return (
    <div className="chronos-calendar-date-picker-time">
      <CalendarTimeSlider
        name="hour"
        calendar={calendar}
        update={handleTimeUpdate}
        value={date.hour}
      />
      <CalendarTimeSlider
        name="minute"
        calendar={calendar}
        update={handleTimeUpdate}
        value={date.minute}
      />
      <CalendarTimeSlider
        name="second"
        calendar={calendar}
        update={handleTimeUpdate}
        value={date.second}
      />
    </div>
  );
}

function CalendarTimeSlider({ name, calendar, update, value }) {
  const [timeValue, setTimeValue] = useState(value);
  const unit = calendar.time[name] || {
    name: 'Second',
    plural: 'Seconds',
    duration: '1',
  };
  const unitName = unit.plural;
  const dayUnit = calendar.time.day;
  const hourUnit = calendar.time.hour;
  const minuteUnit = calendar.time.minute;
  const min = 0;
  let max = 0;
  switch (name) {
    case 'hour':
      max = bigInt(dayUnit.duration).divide(unit.duration).toJSNumber() - 1;
      break;
    case 'minute':
      max = bigInt(hourUnit.duration).divide(unit.duration).toJSNumber() - 1;
      break;
    case 'second':
      max = bigInt(minuteUnit.duration).toJSNumber() - 1;
      break;
  }

  const handleUnitChange = (ev) => {
    ev.preventDefault();
    let { value } = ev.target;
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }
    if (update) update({ [name]: value });
  };

  useEffect(() => {
    setTimeValue(value);
  }, [value]);
  return (
    <div
      className={
        'chronos-calendar-picker-time-unit ' + `calendar-picker-${unitName}`
      }
    >
      <div className="calendar-picker-time-display">
        <span className="calendar-picker-time-label">{unitName}</span>
        <input
          type="text"
          value={timeValue}
          className="calendar-picker-time-input"
          onChange={handleUnitChange}
        />
      </div>
      <input
        value={timeValue}
        type="range"
        step={1}
        min={min}
        max={max}
        onChange={handleUnitChange}
      />
    </div>
  );
}
